// extracted by mini-css-extract-plugin
export default {"row":"_dRpx5LFBzGSqiJvoljm","cell":"w1p3uE8IOXO3KBuW_pDJ"};